import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Wrench, Globe, Zap } from 'lucide-react'

interface Props {
  onSelectDiy: () => void
  onSelectBrowser: () => void
  onSelectRequest: () => void
}

export default function SelectionView({ onSelectDiy, onSelectBrowser, onSelectRequest }: Props) {
  const handleKeyDown = (callback: () => void) => (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      callback()
    }
  }

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card
          className="cursor-pointer hover:border-primary/50 hover:bg-muted/50 transition-colors"
          role="button"
          tabIndex={0}
          onClick={onSelectDiy}
          onKeyDown={handleKeyDown(onSelectDiy)}
        >
          <CardContent className="p-6 text-center space-y-4">
            <div className="mx-auto rounded-xl bg-primary/10 p-4 w-fit">
              <Wrench className="h-8 w-8 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground">Integração via API</h3>
            <p className="text-sm text-muted-foreground">
              Use seu agente de IA para integrar qualquer ferramenta usando credenciais e documentação da API.
            </p>
            <Badge variant="purple"><Zap className="h-3 w-3" /> Recomendado</Badge>
          </CardContent>
        </Card>

        <Card
          className="cursor-pointer hover:border-primary/50 hover:bg-muted/50 transition-colors"
          role="button"
          tabIndex={0}
          onClick={onSelectBrowser}
          onKeyDown={handleKeyDown(onSelectBrowser)}
        >
          <CardContent className="p-6 text-center space-y-4">
            <div className="mx-auto rounded-xl bg-primary/10 p-4 w-fit">
              <Globe className="h-8 w-8 text-primary" />
            </div>
            <h3 className="font-semibold text-foreground">Integração via navegador</h3>
            <p className="text-sm text-muted-foreground">
              Convide seu agente para usar uma ferramenta pelo navegador, assim como você faria com uma pessoa.
            </p>
          </CardContent>
        </Card>
      </div>

      <p className="text-center text-sm text-muted-foreground">
        Quer solicitar uma integração nativa?{' '}
        <button
          type="button"
          onClick={onSelectRequest}
          className="text-primary hover:underline cursor-pointer"
        >
          Solicite para nosso time
        </button>
      </p>
    </div>
  )
}
